export const SELECTED_OPTION = 'SELECTED_OPTION';
export function selectedOption(item) {
  return {
    type: SELECTED_OPTION,
    item,
  };
}
